import React from 'react';
import { BulletListLayoutProps } from 'ui-builder';

export default function BulletListLayout(
  props: BulletListLayoutProps,
) {
  return (
    <ul className={props.className}>
      {props.items.map((item) => (
        <li
          key={`item-list-${item}`}
          className={props.itemClassName}
        >
          {item}
        </li>
      ))}
    </ul>
  );
}
